import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../services/sysadmin.service";
import { ChangeIntsModel } from "../ChangeIntsModel";
import { MSCAddUserGroupComponent } from "./mscadd-user-group/mscadd-user-group.component";

@Component({
	selector: "caass-manage-school-container-user-table",
	templateUrl: "./manage-school-container-user-table.component.html",
	styleUrls: ["./manage-school-container-user-table.component.css"],
})
export class ManageSchoolContainerUserTableComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService) {}

	ngOnInit(): void {}

	ngOnChanges() {
		this.errorMessage = "";

		if (this.SelectedContainer != undefined && this.SelectedContainer != null) {
			this.loadUserGroupList();
		}
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() SelectedContainer: any;

	SelectedUserGroups: any = null;
	lstUserGroups: any = [];
	lstUserLevelDesc: any = [];
	lstActive: any = [];

	cols = [
		{ field: "UserGroupCD", header: "Code" },
		{ field: "UserGroupDesc", header: "Description" },
		{ field: "UserLevelDesc", header: "User Level" },
		{ field: "Active", header: "Active" },
	];

	pagerows: any = 5;
	pagefirst: any = 0;

	user: any;
	errorMessage: any = "";

	ToggleText: any = "Deactivate";

	loading: any = false;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	loadUserGroupList() {
		this.loading = true;

		var result = this.sysAdminService.SchoolGroupGetUserGroups(this.SelectedContainer.SchoolGroupID);
		result.subscribe(
			(response) => {
				this.lstUserGroups = response;

				for (var i = 0; i < this.lstUserGroups.length; i++) {
					var next = this.lstUserGroups[i];
					next.Active = this.ActiveText(next.Active);
				}

				this.lstUserLevelDesc = Array.from(new Set(this.lstUserGroups.map((item: any) => item.UserLevelDesc))).sort();
				this.lstActive = Array.from(new Set(this.lstUserGroups.map((item: any) => item.Active))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.SelectedContainer == undefined || this.SelectedContainer == null) {
			this.errorMessage = "Select a School Container to add User Groups to";
			return;
		}

		var ref = this.dialogService.open(MSCAddUserGroupComponent, {
			header: "Add User Groups",
			width: "fit-content",
			data: {
				SchoolGroupID: this.SelectedContainer.SchoolGroupID,
				SelectedUserGroups: this.lstUserGroups,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadUserGroupList();
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		var lstUserGroupID: number[] = [];

		for (var i = 0; i < this.SelectedUserGroups.length; i++) {
			var next = Number(this.SelectedUserGroups[i].UserGroupID);
			lstUserGroupID = [...lstUserGroupID, next];
		}

		//Create Query Data
		let data: ChangeIntsModel = {
			MainID: this.SelectedContainer.SchoolGroupID,
			IDList: lstUserGroupID,
		};

		//Call SP
		var result = this.sysAdminService.SchoolGroupRemoveUserGroups(data);
		result.subscribe(
			(response) => {
				this.loadUserGroupList();
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////

	ActiveText(val) {
		return val == 1 ? "Active" : "Inactive";
	}
}
